import React, { useEffect, useState } from "react";
import { Table, Spinner, Button } from '@themesberg/react-bootstrap';
import { GetApiRequest } from "../services/api";
import { toast } from '../components/Toaster';

export default () => {
  const [loading, setLoading] = useState(false);
  const [books, setBooks] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, totalBooks: 0, limit: 20, hasMore: false });

  const fetchBlocked = async (page) => {
    setLoading(true);
    try {
      const res = await GetApiRequest('v1/admin/books/blocked', { page });
      const data = res?.data?.data || {};
      setBooks(data.books || []);
      setPagination(data.pagination || { currentPage: 1, totalPages: 1, totalBooks: 0, limit: 20, hasMore: false });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to load blocked books', e);
      toast.error('Failed to load blocked books');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlocked(pagination.currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage]);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center my-5"><Spinner animation="border" role="status" /></div>
      ) : (
        <Table responsive hover className="table-centered table-nowrap rounded mb-4">
          <thead className="thead-light">
            <tr>
              <th>Book ID</th>
              <th>Title</th>
              <th>Author</th>
              <th>Reason</th>
              <th>Blocked By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {books.map(b => (
              <tr key={b._id}>
                <td>{b.bookId}</td>
                <td>{b.bookTitle}</td>
                <td>{b.bookAuthor}</td>
                <td>{b.reason}</td>
                <td>{b.blockedBy?.name || '-'}</td>
                <td>{new Date(b.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
            {books.length === 0 && (
              <tr><td colSpan={6} className="text-center text-muted">No blocked books</td></tr>
            )}
          </tbody>
        </Table>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <div className="small text-muted">Total: {pagination.totalBooks}</div>
        <div>
          <Button size="sm" variant="outline-primary" className="me-2" disabled={pagination.currentPage <= 1} onClick={() => setPagination(p => ({ ...p, currentPage: Math.max(1, p.currentPage - 1) }))}>Prev</Button>
          <span className="small me-2">Page {pagination.currentPage} of {pagination.totalPages}</span>
          <Button size="sm" variant="outline-primary" disabled={pagination.currentPage >= pagination.totalPages} onClick={() => setPagination(p => ({ ...p, currentPage: p.currentPage + 1 }))}>Next</Button>
        </div>
      </div>
    </>
  );
};


